import React from 'react';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/shared/Footer';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeOneHeader from '../Home/HomeOneHeader/HomeOneHeader';
import PortfolioArea from './PortfolioArea/PortfolioArea';
import BlogFooter from '../Blogs/BlogFooter/BlogFooter';

const Portfolio = () => {
   return (
      <>
         <PageHelmet pageTitle="Portfolio Page" />

         <HomeOneHeader/>
         <CommonPageHeader title="Our Programs" subtitle="Programs" />
         <PortfolioArea/>
         <BlogFooter/>
      </>
   );
};

export default Portfolio;